<script setup lang="ts">
import {ref, withDefaults, defineProps, watch, computed} from "vue"
import SpeedAlertSubSetting from "@/components/VehicleFormParts/SpeedAlertSubSetting.vue";
import SpeedAlertSubPreSetting from "@/components/VehicleFormParts/SpeedAlertSubPreSetting.vue";
import i18n from '@/lang/i18n';

const props = withDefaults(defineProps<{
  modelValue: Record<string, string | number>,
  formInputs: Record<string, string | number>,
  selectDefault: boolean,
  errors: Record<string, string | number>,
  isInstallationOffice: boolean,
}>(), {
  selectDefault: false,
  isInstallationOffice: false,
})
const emit = defineEmits<{
  (e: 'update:modelValue', value: Record<string, string | boolean>): void;
}>();

const readonlyInputs = ref<any[]>([]);

const form = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
})

watch(() => props.formInputs, () => {
  if (!props.formInputs?.form?.speed_alert) {
    return;
  }
  const key = Object.keys(props.formInputs.default_params)[0];
  readonlyInputs.value = Object.keys(props.formInputs.default_params[key]?.parameters?.speed_alert ?? []);
});
</script>

<template>
  <template v-if="!!formInputs?.form?.speed_alert">
    <v-card class="my-4 pa-4">
      <v-card-title class="headline">
        {{ i18n.global.t('pages.vehicles.form.iniFileSetting.speedAlert.title') }}
      </v-card-title>
      <v-card-subtitle>
        {{ i18n.global.t('pages.vehicles.form.iniFileSetting.speedAlert.subtitle') }}
      </v-card-subtitle>
      <v-card-text>
        <SpeedAlertSubSetting
          v-model="form"
          :selectDefault="selectDefault"
          :errors="errors"
          :formInputs="formInputs"
          :operationOfficeId="null"
          :deviceId="null"
          :isInstallationOffice="isInstallationOffice"
        />
        <SpeedAlertSubPreSetting
          v-model="form"
          :selectDefault="selectDefault"
          :errors="errors"
          :formInputs="formInputs"
          :operationOfficeId="null"
          :deviceId="null"
          :isInstallationOffice="isInstallationOffice"
        />
      </v-card-text>
    </v-card>
  </template>
</template>

<style scoped>
.headline {
  font-size: 24px;
  font-weight: bold;
  color: #0088a6;
}
</style>
